import { FC, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const Navigation: FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Nav>
      <div className="container">
        <NavFlexContainer>
          <NavBrandContainer>
            <NavBrand as={Link} to="/">Matt Barbour</NavBrand>
          </NavBrandContainer>
          <MobileMenuButton onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </MobileMenuButton>
          <NavLinksContainer className={isMenuOpen ? 'open' : ''}>
            {isHomePage ? (
              <>
                <NavLink href="#software-projects">Software projects</NavLink>
                <NavLink href="#real-world-projects">Real world projects</NavLink>
              </>
            ) : (
              <NavLink as={Link} to="/">Back to Home</NavLink>
            )}
          </NavLinksContainer>
        </NavFlexContainer>
      </div>
    </Nav>
  );
};

const Nav = styled.nav`
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const NavFlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
`;

const NavBrandContainer = styled.div`
  flex: 1;
`;

const NavBrand = styled.a`
  font-family: var(--font-primary);
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  text-decoration: none;
  &:hover {
    color: #3498db;
  }
`;

const NavLinksContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background-color: #ffffff;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &.open {
      display: flex;
    }
  }
`;

const NavLink = styled.a`
  font-family: var(--font-primary);
  color: #2c3e50;
  font-weight: 500;
  transition: color 0.3s ease;
  text-decoration: none;
  &:hover {
    color: #3498db;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    padding: 0.5rem 0;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #2c3e50;
    transition: all 0.3s ease;
  }
`;

export default Navigation;
